"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselItemId = void 0;
var CarouselItemId;
(function (CarouselItemId) {
    CarouselItemId["Appointment"] = "APPOINTMENT";
    CarouselItemId["AvailablePartners"] = "AVAILABLE_PARTNERS";
    CarouselItemId["ConfirmFinishRepair"] = "CONFIRM_FINISH_REPAIR";
    CarouselItemId["ConfirmFinishSales"] = "CONFIRM_FINISH_SALES";
    CarouselItemId["ContactInfo"] = "CONTACT_INFO";
    CarouselItemId["CustomerLocations"] = "CUSTOMER_LOCATIONS";
    CarouselItemId["CustomerLocationsRecovered"] = "CUSTOMER_LOCATIONS_RECOVERED";
    CarouselItemId["CustomerLookup"] = "CUSTOMER_LOOKUP";
    CarouselItemId["CustomForm"] = "CUSTOM_FORM";
    CarouselItemId["IssueDetails"] = "ISSUE_DETAILS";
    CarouselItemId["IssueSpecifier"] = "ISSUE_SPECIFIER";
    CarouselItemId["MediaDetail"] = "MEDIA_DETAIL";
    CarouselItemId["MediaUpload"] = "MEDIA_UPLOAD";
    CarouselItemId["RepairAddress"] = "REPAIR_ADDRESS";
    CarouselItemId["RepairAddressCorrection"] = "REPAIR_ADDRESS_CORRECTION";
    CarouselItemId["RepairAddressNotFound"] = "REPAIR_ADDRESS_NOT_FOUND";
    CarouselItemId["RepairComments"] = "REPAIR_COMMENTS";
    CarouselItemId["RepairContactInfo"] = "REPAIR_CONTACT_INFO";
    CarouselItemId["RepairSummary"] = "REPAIR_SUMMARY";
    CarouselItemId["SalesAddress"] = "SALES_ADDRESS";
    CarouselItemId["SalesAddressCorrection"] = "SALES_ADDRESS_CORRECTION";
    CarouselItemId["SalesAddressNotFound"] = "SALES_ADDRESS_NOT_FOUND";
    CarouselItemId["SalesSummary"] = "SALES_SUMMARY";
    CarouselItemId["ScheduleCalendarRepair"] = "SCHEDULE_CALENDAR_REPAIR";
    CarouselItemId["ScheduleEmergency"] = "SCHEDULE_EMERGENCY";
    CarouselItemId["ScheduleMaintenanceExpired"] = "SCHEDULE_MAINTENANCE_EXPIRED";
    CarouselItemId["ScheduleMaintenanceNoTimeSlots"] = "SCHEDULE_MAINTENANCE_NO_TIME_SLOTS";
    CarouselItemId["SchedulePreference"] = "SCHEDULE_PREFERENCE";
    CarouselItemId["SchedulePreferenceSales"] = "SCHEDULE_PREFERENCE_SALES";
    CarouselItemId["ServiceAreaRepair"] = "SERVICE_AREA_REPAIR";
    CarouselItemId["ServiceAreaSales"] = "SERVICE_AREA_SALES";
    CarouselItemId["ServiceType"] = "SERVICE_TYPE";
    CarouselItemId["SystemComments"] = "SYSTEM_COMMENTS";
    CarouselItemId["SystemEnergy"] = "SYSTEM_ENERGY";
    CarouselItemId["SystemEquipment"] = "SYSTEM_EQUIPMENT";
    CarouselItemId["Unknown"] = "UNKNOWN";
})(CarouselItemId = exports.CarouselItemId || (exports.CarouselItemId = {}));
